import { createAction, props } from '@ngrx/store';
import { CreateRoleRequest, Rights, Role, Roles, UpdateRoleRequest, User } from '../../models/user-management.models';

// Load Users
export const loadUsers = createAction('[User Management] Load Users');
export const loadUsersSuccess = createAction('[User Management] Load Users Success', props<{ users: User[] }>());
export const loadUsersFailure = createAction('[User Management] Load Users Failure', props<{ error: string }>());

// Load Roles
export const loadRoles = createAction('[User Management] Load Roles');
export const loadRolesSuccess = createAction('[User Management] Load Roles Success', props<{ roles: Roles }>());
export const loadRolesFailure = createAction('[User Management] Load Roles Failure', props<{ error: string }>());

// Load Rights
export const loadRights = createAction('[User Management] Load Rights');
export const loadRightsSuccess = createAction('[User Management] Load Rights Success', props<{ assignedRights: string[] }>());
export const loadRightsFailure = createAction('[User Management] Load Rights Failure', props<{ error: string }>());

// Load User Rights
export const loadUserRights = createAction('[User Management] Load User Rights', props<{ userId: string }>());
export const loadUserRightsSuccess = createAction('[User Management] Load User Rights Success', props<{ rights: Rights }>());
export const loadUserRightsFailure = createAction('[User Management] Load User Rights Failure', props<{ error: string }>());

// Create Role
export const createRole = createAction('[User Management] Create Role', props<{ role: CreateRoleRequest }>());
export const createRoleSuccess = createAction('[User Management] Create Role Success', props<{ role: Role }>());
export const createRoleFailure = createAction('[User Management] Create Role Failure', props<{ error: string }>());

// Update Role
export const updateRole = createAction('[User Management] Update Role', props<{ role: UpdateRoleRequest }>());
export const updateRoleSuccess = createAction('[User Management] Update Role Success', props<{ role: Role }>());
export const updateRoleFailure = createAction('[User Management] Update Role Failure', props<{ error: string }>());

// Delete Role
export const deleteRole = createAction('[User Management] Delete Role', props<{ roleId: string }>());
export const deleteRoleSuccess = createAction('[User Management] Delete Role Success', props<{ roleId: string }>());
export const deleteRoleFailure = createAction('[User Management] Delete Role Failure', props<{ error: string }>());

// Update User Rights
export const updateUserRights = createAction('[User Management] Update User Rights', props<{ userId: string; rights: Rights }>());
export const updateUserRightsSuccess = createAction('[User Management] Update User Rights Success', props<{ rights: Rights }>());
export const updateUserRightsFailure = createAction('[User Management] Update User Rights Failure', props<{ error: string }>());

// UI Actions
export const setSelectedUser = createAction('[User Management] Set Selected User', props<{ user: User | null }>());

export const setSelectedRole = createAction('[User Management] Set Selected Role', props<{ role: Role | null }>());

export const setSearchTerm = createAction('[User Management] Set Search Term', props<{ searchTerm: string }>());

export const setRoleFilter = createAction('[User Management] Set Role Filter', props<{ roleIds: string[] }>());

export const setStatusFilter = createAction('[User Management] Set Status Filter', props<{ status: 'all' | 'active' | 'inactive' }>());

export const clearFilters = createAction('[User Management] Clear Filters');

// Ensure Data Loaded - Smart loading that checks if data exists first
export const ensureUsersLoaded = createAction('[User Management] Ensure Users Loaded');
export const ensureRolesLoaded = createAction('[User Management] Ensure Roles Loaded');
export const ensureRightsLoaded = createAction('[User Management] Ensure Rights Loaded');

// Clear State
export const clearUserManagementState = createAction('[User Management] Clear State');
